export enum EAmenity {
  bathroom = "bathroom",
  coffe_shop = "coffe_shop",
  restaurant = "restaurant",
  pharmacy = "pharmacy",
  wifi = "wifi",
  atm = "atm",
  shopping = "shopping"
}
export enum EConnectorStatus {
  available = 'available',
  preparing = 'preparing',
  charging = 'charging',
  suspendedevse = 'suspendedevse',
  suspendedev = 'suspendedev',
  finishing = 'finishing',
  stopped = 'stopped',
  faulted = 'faulted',
  disconnected = 'disconnected'
}
export enum EChargingSpeedType {
  slow = 'slow',
  fast = 'fast',
  ultra = 'ultra'
}
export enum EConnectorGroupType {
  ccs = 'ccs',
  type = 'type',
  other = 'other'
}

export enum EPaymentType {
  balance = 'balance',
  credit_card = 'credit_card',
  pix = 'pix',

}
export enum EChargingStatus {
  charging = 'charging',
  pending = 'pending',
  canceled = 'canceled',
  concluded = 'concluded'
}
export enum EPaymentStatus {
  pending = 'pending',
  paid = 'paid',
  canceled = 'canceled',
  failed = 'failed'
}
export enum EModal {
  balance = 'balance-modal',
  route = 'route-modal',
  confirm = 'confirm-modal',
  pwa_install = 'pwa-install-modal'
}